import { Routes } from '@angular/router';

import { IssueComponent } from './issue/issue.component';
import { IssueResolver } from './issue.resolver';
import { LabComponent } from './lab/lab.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { StartComponent } from './start/start.component';

export const appRoutes: Routes = [
  { path: '', redirectTo: 'devices', pathMatch: 'full' },
  {
    path: 'devices',
    loadChildren: () => import('./devices/devices.routes').then((m) => m.DEVICES_ROUTES),
  },
  { path: 'issues/:issueType', component: IssueComponent, resolve: { issue: IssueResolver } },
  { path: 'lab', component: LabComponent },
  { path: 'start', component: StartComponent },
  { path: '**', component: PageNotFoundComponent },
];
